export default __webpack_public_path__ + "static/media/pic_uploadVideo.142f6da7.svg";